/* eslint-disable */
// import firebaseAxios from '@/shared/firebase/firebase-axios';
import { db, auth, functions, firebase  } from '@/shared/firebase/firebase-init';
import _ from 'underscore'
import managerModel from '@/entities/manager/manager-model';
import clubModel from '@/entities/club/club-model';
import managerService from '@/entities/manager/manager-service';
import Roles from '@/auth/roles';
const KEY_USERS = 'users'
const KEY_TEAMS = 'teams'
const KEY_CLUBS = 'clubs'
const KEY_PROPERTIES = 'properties'
const KEY_USERS_NO_VERIFIED = 'userNoVerified'

export default {
  list() {
    return new Promise((resolve) => {
      db.ref(KEY_USERS).once('value').then((snapshot) => { 
        const list = []
        snapshot.forEach(childSnapshot => {
          list.push(childSnapshot.val())
        });
        resolve(list)
      });
    });
  },

  find(id) {
    return new Promise((resolve, reject) => {
      
      db.ref(KEY_USERS).child(id).once('value').then((snapshot) => { 
        const model = snapshot.val();
        
        if (!model) {
          reject("Empy user");
        }
    
        resolve(model)
      })
    });  
  },
  
  findByEmail(email) {
    return new Promise((resolve, reject) => {
      db.ref(KEY_USERS).orderByChild("email").equalTo(email).once('value').then((snapshot) => { 
        var model = {}
        snapshot.forEach((it) => {
           model = it.val();  
        })
        
        if (!model == null || _.isEmpty(model)) {
          reject("User no exist");
        }
        
        resolve(model)
      })
    });  
  },

  findUserNoVerifiedByEmail(email) {
    return new Promise((resolve, reject) => {
      var ref = firebase.database().ref(KEY_USERS_NO_VERIFIED);

      ref.orderByChild("email").equalTo(email).once('value', (snapshot) => { 
        var model = {}
        snapshot.forEach((it) => {
           model = it.val();  
        })
        
        if (!model == null || _.isEmpty(model)) {
          reject("User no exist");
        }
        
        resolve(model)
      })
    });  
  },

  update(user) {
    return new Promise((resolve, reject) => {
      db.ref(KEY_USERS).child(user.id).set(user, (error) => {
        
        
        if (error) {
          // The write failed...
          reject(error)
        } else {
          // Data saved successfully!
          resolve()
        }
      })
    });
  },

  addAllUsersProperty(property, loggedUser) {
    console.log(" ADD ALL USERS ", property);
    
    return new Promise((resolve) => {
      db.ref(KEY_USERS).once('value').then((snapshot) => { 
        const list = []
        var updates = {};

        
        snapshot.forEach(childSnapshot => {
          const user  = childSnapshot.val()
          list.push(childSnapshot.val())
          updates['/' + KEY_USERS + '/' + user.id + '/' + KEY_PROPERTIES + '/' + property ] = true;

        });

        db.ref().update(updates, (error) => {
          if (error) {
            reject(error)
          } else {
            resolve()
          }
        })
        resolve(list)
      });
    });
  },

  // 1. findByEmail
  // 2. if NotExist create user
  // 3. else exception userExist
  createAll(model, loggedUser) {
    const emails = model.emails
    const roles = model.roles

    return new Promise((resolve, reject) => {
      if (!emails || !emails.length) {
        reject('emails are required');
      }
  
      if (!roles || !roles.length) {
        reject('roles are required');
      }

      // For each
      emails.forEach((email) => {
        
        // 1. find by email
        this.findByEmail(email).then((user) => {
          
            model.roles = [...new Set(roles.concat(user.roles))];
            // 2. update user
            this.update(model).then(() => {
              resolve()
            }).catch((error) => {
              reject(error)
            });
        }).catch((error) => {

         //create auth user
          var modelToSave = {
            id:  db.ref("userNoVerified").push().key,
            email: email, 
            roles: roles
          }

          // 1. Guardar usuario en lista no verificados
          db.ref("userNoVerified").child(modelToSave.id).set(modelToSave).then((e) => {
             var sendEmailRegistrationUser = functions.httpsCallable('sendEmailRegistrationUser');

             // 2. Enviar el email con enlace para que se registren como manager
             sendEmailRegistrationUser(email).then((result) => {
               if(result.data !=null && result.data.errorInfo){
                 // Error
                 reject(result.data.errorInfo.message)
               }else{
                 // Success
                 resolve()
               }
             })
          }).catch((error) => {
            reject(error)
          })
        })
      });
    });
  },

  create(data, loggedUser) {
    const modelToSave = {
      ... data,
      id: data.id ||  db.ref(KEY_USERS).push().key,
      created: firebase.database.ServerValue.TIMESTAMP,
      modified:  firebase.database.ServerValue.TIMESTAMP,
      createdBy: { id: loggedUser.id, email: loggedUser.email } ,
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    };
     
    return new Promise((resolve, reject) => {
        db.ref(KEY_USERS).child(modelToSave.id).set(modelToSave, (error) => {
          if (error) {
            // The write failed...
            reject(error)
          } else {
            // Data saved successfully!
            resolve()
          }
        });
      });
    },


  createUserNoVerifiedAndSendEmailManager(model) {
    return new Promise((resolve, reject) => {


      // 1. Guardar usuario en lista no verificados
      db.ref("userNoVerified").child(model.id).set(model).then(() => {
        var sendEmailRegistrationManager = functions.httpsCallable('sendEmailRegistrationManager');

        // 2. Enviar el email con enlace para que se registren como manager
        sendEmailRegistrationManager(model.email).then((result) => {

          if(result.data !=null && result.data.errorInfo){
            
            //Error creating user
            this.dismissibleAlertText = result.data.errorInfo.message
            reject(result.data.errorInfo.message)
          }else{
            // 3. Avisar a los clubs que se le ha enviado el correo al manager (statusManager="invited")
            _.each(model.clubs, (value, key, obj) => {
              db.ref('clubs').child(key).child('statusManager').set("invited")
            })

              resolve()
          }
        }).catch((error) => {
          reject(error)
        })
      }).catch((error) => {
        reject(error)
      })
    });  
  },
  /**
   * Función que crea un usuario manager asignandole el club con el rol de clubManager
   * 
   * @param {*} club 
   */
  createUserManagerSendEmail(club, loggedUser){
    return new Promise((resolve, reject) => {
      console.log("<---- CREATE USER MANAGER ");
      console.log(club);
      

      var clubs = {}; // create an empty array
      var roles = ['clubManager']; // create an empty array

      clubs[club.id] = clubModel.forManager(club)

      var modelToSave = {
        email: club.emailManager.trim(), 
        roles: roles, 
        clubs: clubs, 
        typeManager: 'clubManager'
      }

      // 1. Buscamos si el manager tiene usuario, es decir, que ya se ha registrado
      managerService.findByEmail(modelToSave.email)
      .then((manager) => {
        console.log("<---- 1 Registrado");
        console.log(manager);
        
        //manager.roles = [...new Set(roles.concat('clubManager'))];
        
        if (manager.clubs) {
          manager.clubs[club.id] = clubModel.forManager(club)
        } else {
          manager.clubs = clubs
        }
       
        // 2. update manager
        managerService.update(manager, loggedUser).then(() => {
          var updates = {};
          updates['/' + KEY_CLUBS + '/' + club.id + '/' + 'statusManager'] = "verified";
          updates['/' + KEY_CLUBS + '/' + club.id + '/' + 'manager'] = managerModel.forSimple(manager);

          db.ref().update(updates, (error) => {
            if (error) {
              reject(error)
            } else {
              resolve()
            }
          })

          resolve()
        }).catch((error) => {
          reject(error)
        });
      }).catch((error) => {

        // 2. Si no tiene usuario
        // 2.1 Buscamos si el emailManager, tiene invitaciones, es decir, esta en la tabla de usuariosNo
        this.findUserNoVerifiedByEmail(modelToSave.email)
        .then((userNoVerified) => {
          // updadte roles
          modelToSave.roles = _.union(roles, userNoVerified.roles)
          // update clubs
          modelToSave.clubs = userNoVerified.clubs
          modelToSave.clubs[club.id] =  clubModel.forManager(club)
          modelToSave.id = userNoVerified.id

          // 2.2 Modificamos el usuario no verificado
          this.createUserNoVerifiedAndSendEmailManager(modelToSave).then(() => {
            resolve()
          }).catch((error) => {
            reject(error)
          })
        }).catch((error) => {

          // Si no tiene ninguna invitación le asignamos un id nuevo
          modelToSave.id = db.ref("userNoVerified").push().key
          this.createUserNoVerifiedAndSendEmailManager(modelToSave).then(() => {
            resolve()
          }).catch((error) => {
            reject(error)
          })
        })
      })
    })
  },

  findMe(firebaseUser) {       
    return new Promise((resolve, reject) => {
      this.find(firebaseUser.uid)
      .then((user) => {
        var userRoles = user.roles
        var roles = Roles.values

        console.log(roles.clubManager.id);
        
        if (_.contains(userRoles, roles.clubManager.id)){
          managerService.find(user.id)
          .then((manager) => {
            
            var userToAuth = {
              ...user,
              clubs: manager.clubs
            }
            
            resolve(userToAuth)
          }).catch((error) => {
            reject(error)
          })
        } else {
          resolve(user)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  }
};



// WEBPACK FOOTER //
// ./src/user/user-service.js